import log from 'loglevel'
import axios, { type AxiosHeaders } from 'axios'
import { isNil } from 'lodash/fp'

import { url, getCustomHeaders } from 'components/DataProvider/functions'
import { assign } from 'lodash'
import { type Partner } from '@mzc-watchover/adminapp-appsync'

log.setLevel((process.env['LOG_LEVEL'] as log.LogLevelDesc) ?? log.levels.DEBUG)

export const doUpload = async (
  file: string,
  partner: Partial<Partner> | undefined
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const customHeaders = getCustomHeaders(
    {},
    !isNil(partner) ? partner.id : undefined
  ) as AxiosHeaders | undefined
  if (isNil(customHeaders)) return undefined
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  if (!isNil(partner)) {
    assign(headers, { 'X-Partner': partner.id })
  }
  const { status } = await axios.post(
    `${url}/users`,
    { file },
    {
      headers
    }
  )
  return status
}
export const doCognitoUpload = async (
  file: string
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const headers = getCustomHeaders({}, undefined) as AxiosHeaders | undefined
  if (isNil(headers)) return undefined
  const { status } = await axios.post(
    `${url}/cognito/users`,
    { file },
    {
      headers: { Authorization: headers.get('Authorization') }
    }
  )
  return status
}
export const doSolarAccountsUpload = async (
  file: string,
  partner: Partial<Partner>
): Promise<{
  result: { addAccounts: any; updateAccounts: any } | undefined
}> => {
  if (isNil(url)) return { result: undefined }
  const customHeaders = getCustomHeaders({}, partner.id) as
    | AxiosHeaders
    | undefined
  if (isNil(customHeaders)) return { result: undefined }
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  assign(headers, { 'X-Partner': partner.id })
  const { status, data } = await axios.post(
    `${url}/solarAccounts`,
    { file },
    {
      headers
    }
  )
  return { result: status === 200 ? data : undefined }
}
export const doSolarAccountsDownloadFormat = async (
  partner: Partial<Partner>
): Promise<{ data: string | undefined }> => {
  if (isNil(url)) return { data: undefined }
  const customHeaders = getCustomHeaders({}, partner.id) as
    | AxiosHeaders
    | undefined
  if (isNil(customHeaders)) return { data: undefined }
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  assign(headers, { 'X-Partner': partner.id })
  const { status, data } = await axios.get(`${url}/solarAccounts/format`, {
    headers
  })
  return status === 200 ? data : { data: undefined }
}
export const doMappingsUpload = async (
  file: string,
  partner: Partial<Partner>
): Promise<{
  result: { addAccounts: any; updateAccounts: any } | undefined
}> => {
  if (isNil(url)) return { result: undefined }
  const customHeaders = getCustomHeaders({}, partner.id) as
    | AxiosHeaders
    | undefined
  if (isNil(customHeaders)) return { result: undefined }
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  assign(headers, { 'X-Partner': partner.id })
  const { status, data } = await axios.post(
    `${url}/mappings`,
    { file },
    {
      headers
    }
  )
  return { result: status === 200 ? data : undefined }
}
